import Vue from 'vue'

/**
 * IMAGES:
 * 
 * Register app images here.  $images is attached to the Vue instance
 */
const baseUrl = `${process.env.VUE_APP_URL_BASE}/`
const images = {
    adminVerification: `${baseUrl}media/images/EmailIcon.svg`,
    alderwood: `${baseUrl}media/images/Powered_By_Alderwood_Labs.svg`,
    appointmentReminder: `${baseUrl}media/images/appointment_reminder.png`,
    assignConversations: `${baseUrl}media/images/Assign_Conversations.png`,
    automatingReplies: `${baseUrl}media/images/automating_replies.png`,
    bigSavings: `${baseUrl}media/images/big_savings.png`,
    brandMark: `${baseUrl}media/images/L&M x MessageDesk_primary_brandmark_black&white.svg`,
    brandLogoHorizontal: `${baseUrl}media/images/brand_logo_horizontal.svg`,
    broadcastHome: `${baseUrl}media/images/broadcast_home_img.png`,
    broadcastMessages: `${baseUrl}media/images/Broadcast_Messages.png`,
    broadcastsWhat: `${baseUrl}media/images/broadcasts_what.png`,
    broadcastsTags: `${baseUrl}media/images/broadcasts_tags.png`,
    broadcastsGroup: `${baseUrl}media/images/broadcasts_groups.png`,
    broadcastsCampaign: `${baseUrl}media/images/broadcasts_campaign.png`,
    buildingSite: `${baseUrl}media/images/BuildingAccount.png`,
    businessUse: `${baseUrl}media/images/BusinessUse.png`,
    canada: `${baseUrl}media/images/canada.png`,
    chatbot: `${baseUrl}media/images/chatbot.png`,
    chooseOrganization: `${baseUrl}media/images/Choose_Organization.svg`,
    comboLogo: `${baseUrl}media/images/L&M x MessageDesk_combined_horizontal_black&white.png`,
    contactsEmpty: `${baseUrl}media/images/Custom-Plan-MessageDesk.png`,
    downloadIcon: `${baseUrl}media/images/DownloadIcon.svg`,
    exploreInbox1on1: `${baseUrl}media/images/explore_inbox_1on1.png`,
    exploreInboxTemplates: `${baseUrl}media/images/explore_inbox_templates.png`,
    exploreInboxOpenClose: `${baseUrl}media/images/explore_inbox_openclose.png`,
    exploreInboxStatus: `${baseUrl}media/images/explore_inbox_status.png`,
    exploreInboxFilter: `${baseUrl}media/images/explore_inbox_filter.png`,
    helpModule: `${baseUrl}media/images/Help_Module.png`,
    highFive: `${baseUrl}media/images/high_five.png`,
    huggingFace: `${baseUrl}media/images/hugging_face.png`,
    iphone: `${baseUrl}media/images/phone-bezel-dark.svg`,
    filterIcon: `${baseUrl}media/images/FilterIcon.svg`,
    googleMapsIcon: `${baseUrl}media/images/google_maps_icon.png`,
    handWave: `${baseUrl}media/images/hand_wave.png`,
    inboxCoverage: `${baseUrl}media/images/inboxCoverage.png`,
    intuitSignin: `${baseUrl}media/images/Qbo/IntuitSignIn-lg-blue@2x.jpg`,
    invoiceWorkflow: `${baseUrl}media/images/invoiceWorkflow.png`,
    marty: `${baseUrl}media/images/marty.gif`,
    messageForm: `${baseUrl}media/images/messageForm.png`,
    messagingScale: `${baseUrl}media/images/messaging_scale.png`,
    moreConversations: `${baseUrl}media/images/more_conversations.png`,
    noConversations: `${baseUrl}media/images/inbox-zero.svg`,
    noCustomers: `${baseUrl}media/images/NoCustomers.svg`,
    noDocuments: `${baseUrl}media/images/NoDocuments.svg`,
    noGroups: `${baseUrl}media/images/NoGroups.svg`,
    noInvitations: `${baseUrl}media/images/NoInvitations.svg`,
    noInvoices: `${baseUrl}media/images/NoInvoices.svg`,
    noMessages: `${baseUrl}media/images/InboxIcon.svg`,
    noNotifications: `${baseUrl}media/images/NoNotifications.png`,
    noTasks: `${baseUrl}media/images/NoTasks.svg`,
    noSearch: `${baseUrl}media/images/NoSearch.svg`,
    oneToMany: `${baseUrl}media/images/oneToManyIcon.svg`,
    organizationImg: `${baseUrl}media/images/organization_image.png`,
    partyPopper: `${baseUrl}media/images/party_popper.png`,
    paymentSwipe: `${baseUrl}media/images/PaymentSwipe.svg`,
    personalUse: `${baseUrl}media/images/PersonalUse.png`,
    phoneWithArrow: `${baseUrl}media/images/phone_with_arrow.png`,
    poweredBy: `${baseUrl}media/images/powered-by.svg`,
    productAnnouncement: `${baseUrl}media/images/product_announcement.svg`,
    purpleHeart: `${baseUrl}media/images/purple_heart.png`,
    qboConnectButton: `${baseUrl}media/images/Qbo/C2QB_green_btn_lg_default.png`,
    qboLogo: `${baseUrl}media/images/Qbo/qbo.png`,
    qboCircle: `${baseUrl}media/images/Qbo/qbo_circle.png`,
    registerNew: `${baseUrl}media/images/registerNew.png`,
    referStep1: `${baseUrl}media/images/refer_step1.png`,
    referStep2: `${baseUrl}media/images/refer_step2.png`,
    referStep3: `${baseUrl}media/images/refer_step3.png`,
    rightArrow: `${baseUrl}media/images/right_arrow.png`,
    routeConversationsManualAssign: `${baseUrl}media/images/route_conversations_manualAssign.png`,
    routeConversationsAutoAssign: `${baseUrl}media/images/route_conversations_manualAssign.png`,
    routeConversationsAutoRoute: `${baseUrl}media/images/route_conversations_manualAssign.png`,
    routeEngagement: `${baseUrl}media/images/Route_Engagement.png`,
    salesAndMarketing: `${baseUrl}media/images/sales_marketing_template.svg`,
    selectExisting: `${baseUrl}media/images/SelectExisting.svg`,
    selectNumber: `${baseUrl}media/images/SelectNumber.svg`,
    servicesMasthead: `${baseUrl}media/images/All_Services_Masthead.svg`,
    smsPollSurvey: `${baseUrl}media/images/sms_poll_survey.svg`,
    smsNewsletter: `${baseUrl}media/images/sms_newsletter.svg`,
    speechBalloon: `${baseUrl}media/images/speech_balloon.png`,
    sphereLogo: `${baseUrl}media/images/Sphere_Logo_RGB.jpg`,
    splash: `${baseUrl}media/images/MessageDesk-Splash.png`,
    staffAlerts: `${baseUrl}media/images/staff_alerts.svg`,
    startConversationsAutoresponders: `${baseUrl}media/images/start_conversations_autoresponders.png`,
    startConversationsChatbot: `${baseUrl}media/images/start_conversations_chatbot.png`,
    startConversationsForms: `${baseUrl}media/images/start_conversations_forms.png`,
    startTyping: `${baseUrl}media/images/Start_Typing_Message.svg`,
    stripeBadge: `${baseUrl}media/images/Stripe_Badge.png`,
    telephone: `${baseUrl}media/images/telephone_receiver.png`,
    thumbsUp: `${baseUrl}media/images/thumbs_up.png`,
    twoPanelPhonePreview: `${baseUrl}media/images/Two_Panel_Phone_preview.png`,
    uploadDocument: `${baseUrl}media/images/UploadDocument.svg`,
    usa: `${baseUrl}media/images/usa.png`,
    useSupport: `${baseUrl}media/images/useSupport.svg`,
    waveHand: `${baseUrl}media/images/wave_hand.png`,
    welcomeBack: `${baseUrl}media/images/welcomeBack.png`,
    xeroConnect: `${baseUrl}media/images/xeroConnect.svg`,
    xeroDisconnect: `${baseUrl}media/images/xeroDisconnect.svg`,
    xeroLogo: `${baseUrl}media/images/xeroLogo.png`,
    zapier: `${baseUrl}media/images/zapier.svg`,
    clintHeadshot: `${baseUrl}media/images/ClintHeadshot.jpeg`,
    kyleHeadshot: `${baseUrl}media/images/KyleHeadshot.jpg`,
    joshHeadshot: `${baseUrl}media/images/JoshHeadshot.jpeg`,
}

Vue.prototype.$images = images

export default images
